import React, {Component} from 'react';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Step,
  StepLabel,
  Stepper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from '@mui/material';
import {withStyles} from '@mui/styles';
import TagAutocomplete from './TagAutocomplete';
import {FavoriteIcon, JournalPostIcon, LinkIcon, SurveyAttemptIcon,} from '../../../../../helpers/Icons'
import FolderSelector from '../../folders/FolderSelector';
import CloseIcon from "@mui/icons-material/Close";
import UploadThumbnail from "../item-viewer/UploadThumbnail";
import {dateToString, formatLocation} from "../../../../../helpers/FormatUtils";
import FileMap from "../item-map/FileMap";

const rowIconStyle = {
  display: 'inline-block',
  width: 40,
  height: 40,
  verticalAlign: 'text-bottom',
  textAlign: 'right'
};

const styles = () => ({
  dialogPaper: {
    // This ensures the dialog paper is its max-height whatever tab is open.
    maxHeight: 'calc(100% - 24px)',
    maxWidth: 'min(calc(100% - 24px), 1080px)',
    overflow: 'auto',
    margin: 0,
    '& > div:first-child':{
      position: 'sticky',
      left: 0,
      padding: '0.5rem',
      paddingBottom: 0,
    }
  },
  // Partially copied from UploadCard.js.
  card: {
    margin: 8,
  },
  cardContent: {
    margin: '8px',
    padding: 0,
  },
  cardTextField:{
    margin:0,
  },
  cardMedia: {
    height: '225px',
    backgroundSize: 'contain',
    position:'relative',
    '& svg':{
      top: '0',
      position: 'absolute',
      width: '100%',
      height: '100%',
    },
  },
  cellSubtext:{
    fontSize:'0.85em',
    whiteSpace:'nowrap',
    fontWeight:'300',
    lineHeight: '1em'
  },
  rowIcon:rowIconStyle,
  rowIconCell: {
    '& > svg':rowIconStyle,
    '& > img':rowIconStyle
  },
  locationText: {
    whiteSpace:'nowrap',
  },
  actions:{
    position: 'sticky',
    bottom: 0,
    left: 0,
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    display: 'flex',
    flexWrap:'wrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: '0.5rem',
    padding: '0.5rem'
  },
  nav:{
    flex: 1,
    flexBasis: 'min-content',
    display: 'flex',
    flexWrap:'wrap',
    gap: '0.5em'
  },
  close:{
    margin: '0 !important'
  }
});

const makeInitialState = () => ({
  tabValue: 0,
  description: '',
  descriptionAction: 'preserve',
  date: null,
  overwriteDate: false,
  selectedFolder: null,
  overwriteFolder: false,
  keywords: [],
  overwriteKeywords: false,
  people: [],
  overwritePeople: false,
  beme: '',
  overwriteBeme: false,
  emotion: '',
  overwriteEmotion: false,
  location: {},
  overwriteLocation: false,
});

class TagBulkDialog extends Component {
  constructor(props) {
    super(props);
    this.dialogRef = React.createRef();
  }
  state = makeInitialState();

  componentDidUpdate(prevProps) {
    // The state should be reset when the dialog is opened.
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState(makeInitialState);
    }
  }

  updateTagState(index, newState) {
    this.props.updateTagStates([
      ...this.props.tagStates.slice(0, index),
      newState,
      ...this.props.tagStates.slice(index + 1)
    ]);
  }

  updateFileName(index, newName) {
    const tagState = this.props.tagStates[index];
    if (tagState) {
      this.updateTagState(index, {...tagState, name: newName });
    }
  }

  updateDescription(newDescription) {
    this.setState({ description: newDescription });
    this.updateDescriptions(newDescription);
  }

  getBulkChangedTagStates() {
    return this.props.tagStates.map(tagState => {
      const newTagState = {...tagState};//Object.assign({}, tagState);
      if (!newTagState.description || this.state.descriptionAction === 'overwrite') {
        newTagState.description = this.state.description;
      } else if (this.state.descriptionAction === 'append') {
        newTagState.description += this.state.description;
      }
      if (this.state.date && (!newTagState.date || this.state.overwriteDate)) {
        newTagState.date = this.state.date;
      }
      if (this.state.selectedFolder && this.state.overwriteFolder) {
        newTagState.folder = {...this.state.selectedFolder};
      }
      if (newTagState.keywords.length === 0 || this.state.overwriteKeywords) {
        newTagState.keywords = this.state.keywords;
      }
      if (newTagState.people.length === 0 || this.state.overwritePeople) {
        newTagState.people = this.state.people;
      }
      if (this.state.beme && (!newTagState.beme || this.state.overwriteBeme)) {
        newTagState.beme = this.state.beme;
      }
      if (this.state.emotion && (!newTagState.emotion || this.state.overwriteEmotion)) {
        newTagState.emotion = this.state.emotion;
      }
      if (
        this.state.overwriteLocation || !newTagState.location ||
        (
          !newTagState.location.locality &&
          !newTagState.location.region &&
          !newTagState.location.country &&
          newTagState.location.latitude === '' &&
          newTagState.location.longitude === ''
        )
      ) {
        newTagState.location = this.state.location;
      }

      return newTagState;
    })
  }

  handleSave() {
    let updated = this.getBulkChangedTagStates();
    // this.props.updateTagStates(updated);
    this.props.saveSelected(updated);
  }

  renderCardThumbnail(tagState){
    switch (tagState.item_data_type) {
      case 'Upload': return <CardMedia title={tagState.name} className={this.props.classes.cardMedia} ><UploadThumbnail item={tagState} size="md" /></CardMedia>;
      case 'Link': return <CardMedia title={tagState.name} className={this.props.classes.cardMedia}><LinkIcon /></CardMedia>;
      case 'Favorite': return <CardMedia title={tagState.name} className={this.props.classes.cardMedia}><FavoriteIcon /></CardMedia>;
      case 'JournalPost': return <CardMedia title={tagState.name} className={this.props.classes.cardMedia}><JournalPostIcon /></CardMedia>;
      case 'SurveyAttempt': return <CardMedia title={tagState.name} className={this.props.classes.cardMedia}><SurveyAttemptIcon /></CardMedia>;
      default: return <CardMedia image={tagState.thumbnail_url} title={tagState.name} className={this.props.classes.cardMedia} />;
    }
  }

  renderFileNameTab(displayedTagStates) {
    const items = displayedTagStates.map((tagState, i) => {
      const onFileNameChange = event => this.updateFileName(i, event.target.value);

      return (
        <Grid item key={tagState.id}>
          <Card className={this.props.classes.card}>
            {this.renderCardThumbnail(tagState)}
            <CardContent className={this.props.classes.cardContent}>
              <TextField
                required
                fullWidth
                variant="outlined"
                className={this.props.classes.cardTextField}
                value={tagState.name}
                onChange={onFileNameChange}
                size="small"
                margin="dense"
              />
            </CardContent>
          </Card>
        </Grid>
      );
    });
    return (
      <div id="tagBulkNamesSection">
        <p>Review or edit the names of your uploads.</p>
        <Grid container  style={{
          boxSizing: 'content-box',
          width: 'calc(100% + 16px)',
          margin: '0 -8px',
        }}>{items}</Grid>
      </div>
    );
  }

  renderDescriptionTab(displayedTagStates) {
    const onDescriptionChange = event => this.setState({ description: event.target.value });
    const onDescriptionActionChange = event => this.setState({ descriptionAction: event.target.value });
    const onDateChange = newDate => this.setState({ date: newDate });
    const onOverwriteDateChange = event => this.setState({ overwriteDate: event.target.checked });
    const onFolderChange = newFolder => this.setState({ selectedFolder: newFolder });
    const onOverwriteFolderChange = event => this.setState({ overwriteFolder: event.target.checked });
    return (
      <div id="tagBulkDescriptionSection">
        <Grid container spacing={2}>
          <Grid item sm={8} xs={12}>
            <div>
              <TextField
                required
                fullWidth
                variant="outlined"
                label="Description"
                multiline minRows={5}
                value={this.state.description}
                onChange={onDescriptionChange}
                margin="normal"
                InputLabelProps={{shrink: true}}
              />
            </div>
            <div>
              <RadioGroup value={this.state.descriptionAction} onChange={onDescriptionActionChange}>
                <FormControlLabel label="Preserve existing descriptions" value="preserve" control={<Radio />} />
                <FormControlLabel label="Overwrite existing descriptions" value="overwrite" control={<Radio />} />
                <FormControlLabel label="Append to existing descriptions" value="append" control={<Radio />} />
              </RadioGroup>
            </div>
          </Grid>
          <Grid item sm={4} xs={12}>
            <FormControl variant="outlined" style={{ width: '100%' }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Date"
                  inputFormat="MM/dd/yyyy"
                  value={this.state.date}
                  onChange={onDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      margin="normal"
                      variant='outlined'
                    />
                  )}
                />
              </LocalizationProvider>
              {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  required
                  disableToolbar
                  inputVariant="outlined"
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  label="Date"
                  size="small"
                  value={this.state.date}
                  onChange={onDateChange}
                />
              </MuiPickersUtilsProvider> */}
            </FormControl>

            <FolderSelector
              label="Folder"
              selectedFolder={this.state.selectedFolder}
              folderList={this.props.folderList}
              addFolder={this.props.addFolder}
              handleFolderSelect={onFolderChange}
            />
          </Grid>
        </Grid>
        <TagStateTable classes={this.props.classes} tagStates={displayedTagStates} columns={[
          {
            header: 'Description',
            getValue: tagState => tagState.description,
            overwriter: null,
          },
          {
            header: 'Date',
            getValue: tagState => dateToString(tagState.date),
            overwriter: (
              <OverwriteCheckbox
                checked={this.state.overwriteDate}
                onChange={onOverwriteDateChange}
                tooltip="Click the checkbox to overwrite any existing file dates with the one above."
              />
            ),
          },
          {
            header: 'Folder',
            getValue: tagState => tagState.folder.name,
            overwriter: (
              <OverwriteCheckbox
                checked={this.state.overwriteFolder}
                onChange={onOverwriteFolderChange}
                tooltip="Click the checkbox to move all items to selected folder."
              />
            ),
          },
        ]} />
      </div>
    );
  }

  renderTagsTab(displayedTagStates) {
    const updateKeywords = value => this.setState({ keywords: value });
    const updatePeople = value => this.setState({ people: value });
    const onBemeChange = event => this.setState({ beme: event.target.value });
    const onEmotionChange = event => this.setState({ emotion: event.target.value });
    const onOverwriteKeywordsChange = event => this.setState({ overwriteKeywords: event.target.checked });
    const onOverwritePeopleChange = event => this.setState({ overwritePeople: event.target.checked });
    const onOverwriteBemeChange = event => this.setState({ overwriteBeme: event.target.checked });
    const onOverwriteEmotionChange = event => this.setState({ overwriteEmotion: event.target.checked });
    return (
      <div id="tagBulkTagsSection">
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <div>
              <TagAutocomplete
                label="Keywords"
                items={this.state.keywords}
                options={this.props.keywordsList}
                getOptionLabel={k => k.text}
                updateItems={updateKeywords}
              />
            </div>
            <div>
              <TagAutocomplete
                label="People"
                items={this.state.people}
                options={this.props.peopleList}
                getOptionLabel={p => p.name}
                updateItems={updatePeople}
              />
            </div>
          </Grid>
          <Grid item sm={6} xs={12}>
            <div>
              <FormControl required variant="outlined" size="small" margin="dense" style={{ width: '100%' }}>
                <InputLabel>Beme</InputLabel>
                <Select
                  value={this.state.beme}
                  onChange={onBemeChange}
                  input={<OutlinedInput margin='dense' label="Beme" />}
                >
                  <MenuItem value='Aspiration' >Aspiration</MenuItem>
                  <MenuItem value='Attitude'>Attitude</MenuItem>
                  <MenuItem value='Belief'>Belief</MenuItem>
                  <MenuItem value='Feeling'>Feeling</MenuItem>
                  <MenuItem value='Mannerism'>Mannerism</MenuItem>
                  <MenuItem value='Personality'>Personality</MenuItem>
                  <MenuItem value='Perspective' >Perspective</MenuItem>
                  <MenuItem value='Recollection'>Recollection</MenuItem>
                  <MenuItem value='Relationship' >Relationship</MenuItem>
                  <MenuItem value='Skill'>Skill</MenuItem>
                  <MenuItem value='Value'>Value</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div>
              <FormControl required variant="outlined" size="small" margin="dense" style={{ width: '100%' }}>
                <InputLabel>Emotion</InputLabel>
                <Select
                  required
                  value={this.state.emotion}
                  onChange={onEmotionChange}
                  input={<OutlinedInput margin='dense' label="Emotion" />}
                >
                  <MenuItem value="Angry">Angry</MenuItem>
                  <MenuItem value="Annoyed">Annoyed</MenuItem>
                  <MenuItem value="Happy">Happy</MenuItem>
                  <MenuItem value="Neutral">Neutral</MenuItem>
                  <MenuItem value="Pleased">Pleased</MenuItem>
                  <MenuItem value="Sad">Sad</MenuItem>
                  <MenuItem value="Scared">Scared</MenuItem>
                  <MenuItem value="Surprised">Surprised</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Grid>
        </Grid>
        <TagStateTable classes={this.props.classes} tagStates={displayedTagStates} columns={[
          {
            header: 'Keywords',
            getValue: tagState => tagState.keywords.map(k => typeof(k) === "string" ? k : k.text).join(', '),
            overwriter: (
              <OverwriteCheckbox
                checked={this.state.overwriteKeywords}
                onChange={onOverwriteKeywordsChange}
                tooltip="Click the checkbox to overwrite any existing file keywords with the one(s) above."
              />
            ),
          },
          {
            header: 'People',
            getValue: tagState => tagState.people.map(p => typeof(p) === "string" ? p : p.name).join(', '),
            overwriter: (
              <OverwriteCheckbox
                checked={this.state.overwritePeople}
                onChange={onOverwritePeopleChange}
                tooltip="Click the checkbox to overwrite any existing file people with the one(s) above."
              />
            ),
          },
          {
            header: 'Beme',
            getValue: tagState => tagState.beme,
            overwriter: (
              <OverwriteCheckbox
                checked={this.state.overwriteBeme}
                onChange={onOverwriteBemeChange}
                tooltip="Click the checkbox to overwrite any existing file bemes with the one above."
              />
            ),
          },
          {
            header: 'Emotion',
            getValue: tagState => tagState.emotion,
            overwriter: (
              <OverwriteCheckbox
                checked={this.state.overwriteEmotion}
                onChange={onOverwriteEmotionChange}
                tooltip="Click the checkbox to overwrite any existing file emotions with the one above."
              />
            ),
          },
        ]} />
      </div>
    );
  }

  renderLocationTab(displayedTagStates) {
    const updateLocation = newLocation => this.setState({ location: newLocation });
    const onOverwriteLocationChange = event => this.setState({ overwriteLocation: event.target.checked });
    return (
      <div id="tagBulkLocationSection">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FileMap
              size="large"
              isDraggable={true}
              updateLocation={updateLocation}
              location={this.state.location}
            />
          </Grid>
        </Grid>
        <TagStateTable classes={this.props.classes} tagStates={displayedTagStates} columns={[
          {
            header: 'Location',
            getValue: tagState => formatLocation("locationCell", tagState.location, this.props.classes),
            overwriter: (
              <OverwriteCheckbox
                checked={this.state.overwriteLocation}
                onChange={onOverwriteLocationChange}
                tooltip="Click the checkbox to overwrite any existing file locations with the one above."
              />
            ),
          },
        ]} />
      </div>
    );
  }

  testItemField(tagState, field){
    switch (field) {
      case "description":
        return !!tagState.description && tagState.description.length > 0;
      case "date":
        return !!tagState.date;
      case "keywords":
        return tagState.keywords.length > 0;
      case "people":
        return tagState.people.length > 0;
      case "beme":
        return !!tagState.beme;
      case "emotion":
        return !!tagState.emotion;
      case "location":
        return !!tagState.location;
      default:
        // console.log("unknown field", field);
        return false;
    }
  }

  testItemsFields(tagStates, fields){
    for(let i=0; i< fields.length; i++){
      for(let j=0; j<tagStates.length; j++){
        if (!this.testItemField(tagStates[j], fields[i])) {
          return false;
        }
      }
    }
    return true;
  }

  render() {
    const tabData = [
      {
        label: 'File Name',
        render: this.renderFileNameTab.bind(this),
        requiredFields: [],
      },
      {
        label: 'Description',
        render: this.renderDescriptionTab.bind(this),
        requiredFields: [
          // Table format: [field-name, is-set]
          ['description', this.state.description],
          ['date', this.state.date],
        ],
      },
      {
        label: 'Tags',
        render: this.renderTagsTab.bind(this),
        requiredFields: [
          // ['keywords', this.state.keywords.length > 0],
          // ['people', this.state.people.length > 0],
          ['beme', this.state.beme],
          ['emotion', this.state.emotion],
        ],
      },
      {
        label: 'Location',
        render: this.renderLocationTab.bind(this),
        requiredFields: [
          ['location', Object.keys(this.state.location).length > 0],
        ],
      },
    ];
    const tagStates = this.getBulkChangedTagStates();
    const tabsIncompleteFields = tabData.map(({ requiredFields }) => (
      requiredFields
        .filter(([, set]) => !set)
        .map(([fieldName, ]) => fieldName)
    ))
    const steps = tabData.map(({ label }, i) => (
      <Step completed={tabsIncompleteFields[i].length === 0} active={this.state.tabValue === i} key={i}>
        <StepLabel>{label}</StepLabel>
      </Step>
    ));
    const scrollToTop = () => this.dialogRef.current.childNodes[2].firstElementChild.firstElementChild.scrollIntoView();
    const previous = this.state.tabValue - 1;
    const onClickPrevious = () => {
      scrollToTop();
      this.setState({tabValue: previous})
    };
    const next = this.state.tabValue + 1;
    const onClickNext = () => {
      // scroll dialog to top
      scrollToTop();
      this.setState({tabValue: next})
    };
    let continueButton;
    if (tabData[next]) {
      continueButton = (
        <Button
          id="tagBulkNext"
          variant="contained"
          color="primary"
          onClick={onClickNext}
          disabled={tabsIncompleteFields[this.state.tabValue].length > 0 && !this.testItemsFields(tagStates, tabsIncompleteFields[this.state.tabValue])}
        >
          Next
        </Button>
      );
    } else {
      continueButton = (
        <Button
          id="tagBulkSave"
          variant="contained"
          color="primary"
          onClick={this.handleSave.bind(this)}
          disabled={this.props.savingInProgress || (tabsIncompleteFields[this.state.tabValue].length > 0 && !this.testItemsFields(tagStates, tabsIncompleteFields[this.state.tabValue]))}
        >
          Save
        </Button>
      );
    }
    if (tabsIncompleteFields[this.state.tabValue].length > 0) {
      const incompleteList = tabsIncompleteFields[this.state.tabValue];
      const incompleteListed = incompleteList.length > 2
        ? `${incompleteList.slice(0, -1).join(', ')}, and ${incompleteList[incompleteList.length - 1]}`
        : incompleteList.length > 1
          ? `${incompleteList[0]} and ${incompleteList[1]}`
          : incompleteList[0];
      continueButton = (
        <Tooltip title={`Complete the ${incompleteListed} ${incompleteList.length > 1 ? 'fields' : 'field'} to continue.`}>
          {/* This div is needed to make the tooltip appear on a disabled button: */}
          <div style={{ display: 'inline-block' }}>{continueButton}</div>
        </Tooltip>
      );
    }
    let openTab = tabData[this.state.tabValue].render(tagStates);

    return (
      <Dialog
        PaperProps={{id:this.props.id}}
        open={this.props.isOpen}
        // onClose={this.props.closeDialog}
        classes={{ paper: this.props.classes.dialogPaper }}
        ref={this.dialogRef}
      >
        <DialogTitle>
          <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
            {"Tag selected files"}
            <IconButton onClick={this.props.closeDialog} style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent style={{overflow: 'visible', padding: '0 0.5rem'}}>
          <Stepper id="tagStep" activeStep={this.state.tabValue} style={{padding: '0.5rem', flexWrap: 'wrap', gap: '0.5rem 0'}}>{steps}</Stepper>
          {openTab}
        </DialogContent>
        <DialogActions className={this.props.classes.actions}>
          <div className={this.props.classes.nav}>
            <Button
              id="tagBulkPrevious"
              variant="contained"
              color="primary"
              onClick={onClickPrevious}
              disabled={!tabData[previous] || this.props.savingInProgress}
            >
              Previous
            </Button>
            {continueButton}
          </div>
          <Button
            id="tagBulkCancel"
            className={this.props.classes.close}
            onClick={this.props.closeDialog}
            variant="contained"
            color="secondary"
            disabled={this.props.savingInProgress}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const itemTypeRowIcons = {
  'Upload': (tagState) => <UploadThumbnail item={tagState} size="sm" />,
  'Link': (tagState) => <LinkIcon size="large" />,
  'Favorite': (tagState) => <FavoriteIcon size="large" />,
  'JournalPost': (tagState) => <JournalPostIcon size="large" />,
  'SurveyAttempt': (tagState) => <SurveyAttemptIcon size="large" />,
}
function renderRowThumbnail(tagState){
  return itemTypeRowIcons[tagState.item_data_type](tagState);
}

function TagStateTable({ tagStates, columns, classes }) {
  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="none" size="small"></TableCell>
            <TableCell>Files Being Tagged</TableCell>
            {columns.map(({ header, overwriter }, i) => [
              <TableCell align="right" style={{ paddingRight: 0 }} size="small" key={`ow_${i}`}>{overwriter}</TableCell>,
              <TableCell style={{ paddingLeft: 0 }} key={i}>{header}</TableCell>,
            ])}
          </TableRow>
        </TableHead>
        <TableBody>
          {tagStates.map(tagState => (
            <TableRow key={tagState.id}>
              <TableCell align="center" padding="none" className={classes.rowIconCell} >
                {renderRowThumbnail(tagState)}
              </TableCell>
              <TableCell>{tagState.name}</TableCell>
              {columns.map(({ getValue }, i) => [
                <TableCell style={{ paddingRight: 0 }} size="small" key={`pad_${i}`}></TableCell>,
                <TableCell style={{ paddingLeft: 0 }} key={i}>{getValue(tagState)}</TableCell>,
              ])}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

function OverwriteCheckbox({ tooltip, ...checkboxProps }) {
  return (
    <Tooltip title={tooltip}><Checkbox {...checkboxProps} /></Tooltip>
  );
}


export default withStyles(styles)(TagBulkDialog);
